module.exports = __webpack_public_path__ + "static/media/logo-company-login-tc.0c2e5576.png";